import * as yup from 'yup'

export class QuickBooksSyncUploadDto {
  documentFile?: File = undefined
  quickBooksVersion?: string = undefined
  notes?: string = undefined
}

export const quickBooksSyncUploadValidationSchema = yup.object<QuickBooksSyncUploadDto>({
  documentFile: yup
    .mixed()
    .test('File is required.', 'File is required.', value => Boolean(value))
    .test('File must be a .zip.', 'File must be a .zip.', value => {
      if (!value) return false

      return (value as File).name.toLowerCase().endsWith('.zip')
    })
    .required('File is required.'),
  quickBooksVersion: yup
    .string()
    .max(255, 'QuickBooks Version cannot be more than 255 characters.')
    .required('QuickBooks Version is required.'),
  notes: yup.string().max(50, 'Notes cannot be more than 50 characters.')
})
